import th from './th.json'
import en from './en.json'

export const messages = {
  th: th,
  en: en
}



// WEBPACK FOOTER //
// ./src/assets/lang/lang.js